import { render, staticRenderFns } from "./ConversaoVegetacaoNativa.vue?vue&type=template&id=1561be38&lang=pug"
import script from "./ConversaoVegetacaoNativa.vue?vue&type=script&lang=js"
export * from "./ConversaoVegetacaoNativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports